import List from "./list/list.store";
import Individual from "./individual/list.store";
import Export from "./export/teacher_export.store";

export default {
  modules: { List, Individual, Export },
};
